export class ContentFooterPopularTopic {
  heading: any;
  popularTopicsList: ContentFooterPopularTopicItem[];

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['heading']) {
        this.heading = contentjson['heading'];
      }
      if (contentjson['popularTopicsList']) {
        this.popularTopicsList = this.popularTopics(
          contentjson['popularTopicsList']
        );
      }
    }
  }

  private popularTopics(contentjson?: any): ContentFooterPopularTopicItem[] {
    let popularItem: ContentFooterPopularTopicItem[] = [];
    const popularItems = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      let counter = 1;
      for (const value of values) {
        popularItems.set(
          counter,
          new ContentFooterPopularTopicItem(counter, value)
        );
        counter++;
      }
      popularItem = Array.from(popularItems.values());
    }
    return popularItem;
  }
}

export class ContentFooterPopularTopicItem {
  id: any;
  itemtext: any;
  itemUrl: any;
  newwindow: any;

  constructor(id: any, contentjson?: any) {
    if (contentjson) {
      this.id = id;
      if (contentjson['itemtext']) {
        this.itemtext = contentjson['itemtext'];
      } else {
        this.itemtext = '';
      }
      if (contentjson['itemUrl']) {
        this.itemUrl = contentjson['itemUrl'];
      } else {
        this.itemUrl = '';
      }
      if (contentjson['newwindow']) {
        this.newwindow = contentjson['newwindow'];
      } else {
        this.newwindow = '';
      }
    }
  }
}
